import React from 'react';
import includes from 'lodash/includes';
import { Link } from 'react-router';
import map from 'lodash/map';
import some from 'lodash/some';
import filter from 'lodash/filter';
import every from 'lodash/every';
import { Glyphicon } from 'react-bootstrap';
//import { canManifestBeEdited } from './manifest';

export const manifestNumberFormatter = (cell, row) => {
    if (row.manifest) {
        return (
            <Link to={`/manifests/${row.manifest.manifestId}`}>{row.manifest.manifestNumber}</Link>
        );
    }

    return '';
};

export const emaSmaManifestNumberFormatter = (cell, row) => {
    if (row.manifest.emaSmaManifest) {
        return (
            <Link to={`/manifests/${row.manifest.emaSmaManifest.manifestId}`}>
                {row.manifest.emaSmaManifest.manifestNumber}
            </Link>
        );
    }

    return '';
};

export const recoveryActionsFormatter = (cell, row) => {
    if (row.recoveryActions && row.recoveryActions.length > 0) {
        return (
            <div>
                {map(row.recoveryActions, rec => {
                    if (
                        row.abnormality &&
                        row.abnormality.abnormalityType &&
                        row.abnormality.abnormalityId &&
                        row.abnormality.runId &&
                        rec.recoveryActionType &&
                        rec.recoveryActionId
                    ) {
                        let root =
                            row.abnormality.genericAbnormalityType === 'MANIFEST_BASED'
                                ? 'manifests/' + row.abnormality.manifestNavigation.manifestId
                                : 'runs/' + row.abnormality.runId;

                        return (
                            <p key={rec.recoveryActionId}>
                                <Link
                                    to={`${root}/abnormality/${row.abnormality.abnormalityType}/${
                                        row.abnormality.abnormalityId
                                    }/recoveryAction/${rec.recoveryActionType}/${
                                        rec.recoveryActionId
                                    }`}
                                >
                                    {rec.name}
                                </Link>
                            </p>
                        );
                    }
                })}
            </div>
        );
    }

    return <div />;
};

export const abnormalitiesFormatter = (cell, row) => {
    if (row.existingAbnormalities && row.existingAbnormalities.length > 0) {
        return (
            <div>
                {map(row.existingAbnormalities, abn => {
                    if (abn.abnormalityId) {
                        let root =
                            abn.genericAbnormalityType === 'MANIFEST_BASED'
                                ? 'manifests/' + abn.manifestNavigation.manifestId // TODO: has to be abn.manifestNavigation.manifestId
                                : 'runs/' + abn.runId;

                        return (
                            <p key={abn.abnormalityId}>
                                <Link
                                    to={`${root}/abnormality/${abn.abnormalityType}/${
                                        abn.abnormalityId
                                    }`}
                                >
                                    {abn.name}
                                </Link>
                            </p>
                        );
                    }
                })}
            </div>
        );
    }

    return <div />;
};

export const palletsFormatter = (cell, manifestRow, selectedManifests, isEditable) => {
    let field = '';

    if (includes(selectedManifests, manifestRow.manifestId)) {
        if (/*canManifestBeEdited(manifestRow) && */isEditable) {
            field = (
                <div style={{ cursor: 'pointer' }}>
                    {cell}{' '}
                    <Glyphicon
                        glyph="glyphicon glyphicon-pencil"
                        style={{ marginLeft: '3px' }}
                        className="pull-right"
                    />
                </div>
            );
        } else {
            field = <div className="pull-right">{cell}</div>;
        }
    }
    return field;
};

export const rowValidationFormatter = (row, rowIndex, validations, selectedManifestIds) => {
    const isSelected = includes(selectedManifestIds, row.manifest.manifestId);

    if (validations.pallets && !row.totalPallets && isSelected) {
        return 'error-row';
    }
};

export const impactedBoxesFormatter = isEditable => cell => {
    let field = '';

    if (isEditable) {
        field = (
            <div>
                {cell}{' '}
                <Glyphicon
                    glyph="glyphicon glyphicon-pencil"
                    style={{ marginLeft: '3px' }}
                    className="pull-right"
                />
            </div>
        );
    } else {
        field = <div className="pull-right">{cell}</div>;
    }

    return field;
};

export const numberOfKanbansFormatter = (selectedManifestIds, selectedKanbanIds) => (cell, row) => {
    const isManifestSelected = includes(selectedManifestIds, row.manifest.manifestId);

    if (isManifestSelected && every(row.kanbans, k => includes(selectedKanbanIds, k.kanbanId))) {
        return 'ALL';
    } else if (
        isManifestSelected &&
        some(row.kanbans, k => includes(selectedKanbanIds, k.kanbanId))
    ) {
        return 'SOME';
    }

    return 'NONE';
};

export const impactedKanbanBoxesFormatter = (selectedManifestIds, selectedKanbanIds) => (
    cell,
    row
) => {
    const isManifestSelected = includes(selectedManifestIds, row.manifest.manifestId);
    const selectedKanbans = filter(row.kanbans, k => includes(selectedKanbanIds, k.kanbanId));
    const allBoxesAmountEqualsTotal = every(
        selectedKanbans,
        k => parseInt(k.impactedBoxes, 10) === k.totalNumberOfBoxes
    );
    const allBoxesAmountBelowTotal = every(
        selectedKanbans,
        k =>
            parseInt(k.impactedBoxes, 10) > 0 &&
            parseInt(k.impactedBoxes, 10) < k.totalNumberOfBoxes
    );
    const someBoxesAmountBelowTotal = some(selectedKanbans, k => parseInt(k.impactedBoxes, 10) > 0);
    const allBoxesAmountNull = every(
        selectedKanbans,
        k => k.impactedBoxes === null || k.impactedBoxes === ''
    );

    if (isManifestSelected) {
        if (row.kanbans.length === 0) {
            return 'ALL';
        } else if (selectedKanbans.length === 0) {
            return 'NONE';
        } else if (allBoxesAmountNull) {
            return 'ALL';
        } else if (allBoxesAmountEqualsTotal) {
            return 'ALL';
        } else if (allBoxesAmountBelowTotal || someBoxesAmountBelowTotal) {
            return 'SOME';
        }
    }

    return 'NONE';
};
